export const isRequired = (...requeredList: string[]) => requeredList.every((item) => Boolean(item));

const DHL_TRACKING_BASE = 'https://www.dhl.com/cgi-bin/tracking.pl';
const AWB_PATTERN = /^\d{10}$/;

export const buildTrackingUrl = (raw: string): string | null => {
  const trimmed = String(raw ?? '').trim();
  if (!AWB_PATTERN.test(trimmed)) return null;

  // 문자열 → 숫자 변환으로 taint chain 차단 (숫자는 스크립트를 담을 수 없음)
  const awbNum = Number(trimmed);
  if (!Number.isSafeInteger(awbNum) || awbNum < 0) return null;

  const awb = encodeURIComponent(String(awbNum).padStart(10, '0'));

  return `${DHL_TRACKING_BASE}?AWB=${awb}&LINKS=NO&LAN=KOR&TID=KR_KOR`;
};